import React, { Suspense, useEffect, useState } from "react";
import { Switch, Redirect } from "react-router-dom";
import ErrorPage from "../errors/ErrorPage";
import AdminRoute from "./components/AdminRoute";
import {
  UsersListing,
  UserForm,
  ClientListing,
  ClientForm,
  ProjectListing,
  ProjectForm,
  Timer,
  Approvals,
  Reports,
  RitualListing,
  RitualForm,
  UserReport,
  ProposalListing,
  ProposalDetails,
  EndOfPeriod,
  CheckListing,
  EditProfileForm,
  OrgChartPage,
  CoordinationListing,
  PayingAreaListing,
  LogScreen,
  FactoryListing,
  FactoryForm,
  ClosingDateListing,
  ClosingDateForm,
  MessageWhatsapp,
  TrainingListing,
  TrainingForm,
  TrainingSubgroupListing,
  TrainingSubgroupForm,
  TrainingGroupListing,
  TrainingGroupForm,
  HolidayListing,
  HolidayForm,
  ProjectTypeListing,
  ProjectTypeForm
} from "./pages";

export default function AdminPage() {
  const [width, setWidth] = useState(window.innerWidth);

  const resizeEvent = () => {
    if (window.innerWidth !== width) {
      setWidth(window.innerWidth);
    }
  };

  useEffect(() => {
    window.addEventListener("resize", resizeEvent);

    return () => window.removeEventListener("resize", resizeEvent);
  });

  return (
    <Suspense>
      <Switch>
        <Redirect exact from="/admin" to="/admin/timer" />

        {/* SCREEN LOGS */}
        <AdminRoute permissionLevel="ADMIN" exact path="/admin/:slug/logs" component={() => <LogScreen width={width} />} />
        <AdminRoute permissionLevel="ADMIN" exact path="/admin/:slug/logs/:id" component={() => <LogScreen width={width} />} />

        {/* TIMER */}
        <AdminRoute permissionLevel="CONSULTANT" exact path="/admin/timer" component={() => <Timer width={width} />} />

        {/* APROVAÇÕES */}
        <AdminRoute permissionLevel="FINANCIAL" exact path="/admin/aprovacoes" component={() => <Approvals width={width} />} />

        {/* RELATÓRIOS */}
        <AdminRoute permissionLevel="FINANCIAL" exact path="/admin/relatorios" component={() => <Reports width={width} />} />
        <AdminRoute permissionLevel="FINANCIAL" exact path="/admin/profissionais/relatorio" component={(props) => <UserReport width={width} {...props} />} />

        {/* FECHAMENTO */}
        <AdminRoute permissionLevel="FINANCIAL" exact path="/admin/fechamento" component={() => <EndOfPeriod width={width} />} />

        {/* RITUAIS */}
        <AdminRoute permissionLevel="COMMERCIAL" exact path="/admin/rituais" component={() => <RitualListing width={width} />} />
        <AdminRoute permissionLevel="OPERATION" exact path="/admin/rituais/:id/editar" component={RitualForm} />

        {/* PROFISSIONAIS */}
        <AdminRoute permissionLevel="RECRUITMENT" exact path="/admin/profissionais" component={() => <UsersListing width={width} />} />
        <AdminRoute permissionLevel="RECRUITMENT_WITCHOUT_COMMERCIAL" path="/admin/profissionais/adicionar" component={UserForm} />
        <AdminRoute permissionLevel="RECRUITMENT_WITCHOUT_COMMERCIAL" path="/admin/profissionais/:id/editar" component={UserForm} />

        {/* EDITAR */}
        <AdminRoute permissionLevel="CONSULTANT" path="/admin/editar/perfil" component={EditProfileForm} />

        {/* CLIENTES */}
        <AdminRoute permissionLevel="RECRUITMENT" exact path="/admin/clientes" component={() => <ClientListing width={width} />} />
        <AdminRoute permissionLevel="OPERATION" path="/admin/clientes/adicionar" component={ClientForm} />
        <AdminRoute permissionLevel="OPERATION" path="/admin/clientes/:id/editar" component={ClientForm} />

        {/* TIPOS DE PROJETO */}
        <AdminRoute permissionLevel="FINANCIAL" exact path="/admin/tipos-de-projeto" component={() => <ProjectTypeListing width={width} />} />
        <AdminRoute permissionLevel="OPERATION" path="/admin/tipos-de-projeto/adicionar" component={ProjectTypeForm} />
        <AdminRoute permissionLevel="OPERATION" path="/admin/tipos-de-projeto/:id/editar" component={ProjectTypeForm} />

        {/* PROJETOS */}
        <AdminRoute permissionLevel="FINANCIAL" exact path="/admin/projetos" component={() => <ProjectListing width={width} />} />
        <AdminRoute permissionLevel="OPERATION" path="/admin/projetos/adicionar" component={ProjectForm} />
        <AdminRoute permissionLevel="OPERATION" path="/admin/projetos/:id/editar" component={ProjectForm} />

        <AdminRoute permissionLevel="FINANCIAL" path="/admin/organograma" component={OrgChartPage} />

        {/* COORDENACAO */}
        <AdminRoute permissionLevel="FINANCIAL" exact path="/admin/coordenacoes" component={() => <CoordinationListing width={width} />} />

        {/* AREA PAGADORA */}
        <AdminRoute permissionLevel="FINANCIAL" path="/admin/area-pagadora" component={() => <PayingAreaListing width={width} />} />

        {/* FABRICA */}
        <AdminRoute permissionLevel="OPERATION" exact path="/admin/fabrica" component={() => <FactoryListing width={width} />} />
        <AdminRoute permissionLevel="OPERATION" path="/admin/fabrica/adicionar" component={FactoryForm} />
        <AdminRoute permissionLevel="OPERATION" path="/admin/fabrica/:id/editar" component={FactoryForm} />

        {/* PROPOSTAS */}
        <AdminRoute permissionLevel="FINANCIAL" exact path="/admin/propostas" component={() => <ProposalListing width={width} />} />
        <AdminRoute permissionLevel="FINANCIAL" path="/admin/propostas/:id/detalhes" component={ProposalDetails} />

        {/* CHECK */}
        <AdminRoute permissionLevel="COMMERCIAL_WITCHOUT_OPERATION" exact path="/admin/check" component={() => <CheckListing width={width} />} />

        {/* ADMINISTRATIVO */}
        <AdminRoute permissionLevel="OPERATION" exact path="/admin/data-de-fechamento" component={() => <ClosingDateListing width={width} />} />
        <AdminRoute permissionLevel="OPERATION" path="/admin/data-de-fechamento/adicionar" component={ClosingDateForm} />
        <AdminRoute permissionLevel="OPERATION" path="/admin/data-de-fechamento/:id/editar" component={ClosingDateForm} />
        <AdminRoute permissionLevel="OPERATION" exact path="/admin/mensagem-whatsapp" component={() => <MessageWhatsapp width={width} />} />
        <AdminRoute permissionLevel="OPERATION" exact path="/admin/feriados" component={() => <HolidayListing width={width} />} />
        <AdminRoute permissionLevel="OPERATION" path="/admin/feriados/adicionar" component={HolidayForm} />
        <AdminRoute permissionLevel="OPERATION" path="/admin/feriados/:id/editar" component={HolidayForm} />

        {/* TREINAMENTO */}
        <AdminRoute permissionLevel="CONSULTANT" exact path="/admin/treinamentos" component={() => <TrainingListing width={width} />} />
        <AdminRoute permissionLevel="OPERATION" path="/admin/treinamentos/adicionar" component={TrainingForm} />
        <AdminRoute permissionLevel="OPERATION" path="/admin/treinamentos/:id/editar" component={TrainingForm} />
        <AdminRoute permissionLevel="CONSULTANT" exact path="/admin/treinamentos/subgrupos" component={() => <TrainingSubgroupListing width={width} />} />
        <AdminRoute permissionLevel="OPERATION" path="/admin/treinamentos/subgrupos/adicionar" component={TrainingSubgroupForm} />
        <AdminRoute permissionLevel="OPERATION" path="/admin/treinamentos/subgrupos/:id/editar" component={TrainingSubgroupForm} />
        <AdminRoute permissionLevel="CONSULTANT" exact path="/admin/treinamentos/grupos" component={() => <TrainingGroupListing width={width} />} />
        <AdminRoute permissionLevel="OPERATION" path="/admin/treinamentos/grupos/adicionar" component={TrainingGroupForm} />
        <AdminRoute permissionLevel="OPERATION" path="/admin/treinamentos/grupos/:id/editar" component={TrainingGroupForm} />

        {/* ERROR */}
        <AdminRoute permissionLevel="CONSULTANT" path="/admin/*" component={ErrorPage} />
      </Switch>
    </Suspense>
  );
}
